import { IFilterableField } from './filters';
import { EntityOwnerField } from './FilterFields/EntityOwnerFilter/utils';

const BaseFilterableFields: IFilterableField[] = [EntityOwnerField];

export const DataVendorFilterbaleFields: IFilterableField[] = [
  ...BaseFilterableFields,
];

export const ContactFilterableFields: IFilterableField[] = [
  ...BaseFilterableFields,
];

export const DataSetFilterableField: IFilterableField[] = [
  ...BaseFilterableFields,
];
